<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">Interview Test</h3>
      </div>
      <div id="studentForm">
        <div class="card-body" style="padding-right: 3%; padding-left: 3%">

          <div class="row">
            <div class="col-md-6">
              <label>Session *</label>
              <select required class="form-control" v-model="test.ActiveSemesterID" v-on:change="semesterChange()" id="ddlSession">
                <option value="0" selected="selected" disabled="disabled">--Select Semester--</option>
                <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Degree *</label>
              <select required class="form-control" v-on:change="degreeChange()" v-model="test.DegreeID">
                <option value="0" selected="selected" disabled="disabled">--Select Degree--</option>
                <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
              </select>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-6">
              <label>Program *</label>
              <select required class="form-control" v-model="programId">
                <option value="0" selected="selected" disabled="disabled">--Select Program--</option>
                <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
              </select>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Title *</label>
                <input required class="form-control" v-model="test.Name" maxlength="60" />
              </div>
            </div>



          </div>
          <div class="row" style="margin-top: 10px;">

            <div class="col-md-3">
              <div class="form-group">
                <label>Total Marks *</label>
                <input required type="text" class="form-control pull-right" v-mask="'###'" v-model="totalmarks">
                <!-- /.input group -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Date * </label>
                <div class="input-group" id="reservationdate" data-target-input="nearest">
                  <input type="datetime-local" class="form-control" data-target="#reservationdate" v-model="date" required>

                </div>
              </div>
            </div>
            <hr />
            <div class="col-md-12 ">
              <button type="button" v-on:click="loadCandidates()" class="btn btn-success float-right">load Applicants</button>

            </div>

          </div>

          <div class="row" v-show="candidates.length > 0">
            <div class="col-md-12">
              <label>Student List</label>
              <div style="max-height: 700px; overflow-y: scroll">
                <table id="example2" class="table table-sm table-bordered table-color">
                  <thead class="bg-info text-white">
                    <tr>
                      <th>Sr No.</th>
                      <th style="width: 15%; text-align: center">Form No</th>
                      <th style="width: 40%;">Name</th>
                      <th style="width: 40%;">Father Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in candidates">
                      <td style="text-align: center">{{index + 1}}</td>
                      <td style="text-align: center">{{item.FormNo}}</td>
                      <td style="">{{item.Name}}</td>
                      <td style="">{{item.FatherName}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 10px;">
            <div class="col-md-12">
              <div class="form-group">
                <label>Header Text </label>
                <textarea v-model="test.header" name="test.header" id="editorObjective"></textarea>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label>Footer Text </label>
                <textarea v-model="test.footer" name="test.footer" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer" style="text-align: right">
          <input type="submit" v-if="isupdate == false" class="btn btn-success float-right" />
          <button type="button" v-show="isupdate == true" class="btn btn-success" v-on:click="updateEntryTest()">Update</button>
          <button type="button" class="btn btn-primary float-left" v-on:click="Cancel()">Back To List</button>
        </div>
      </div>
    </div>
  </form>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        programs: [],
        degrees: [],
        semesters: [],
        selecteddeptid: 0,
        halls: [],
        test: { footer: '', header: '', InterviewID: '', Name: '', ProgramID: 0, SessionID: 0, DegreeID: 0, ActiveSemesterID: 0 },
        candidates: [],
        totalmarks: "100",
        date: '',
        programId: '',
        selectedPrograms: []
      }
    },
    mounted: function () {
      this.checkEntryTestUpdate();
    },
    updated: function () {
    },
    methods:
    {

      updateEntryTest() {
        var vm = this;




        //vm.test.Header = CKEDITOR.instances['header'].getData();
        //vm.test.Footer = CKEDITOR.instances['footer'].getData();

        startReq();

        axios.post('/api/AdmissionApi/updateInterview?pro=' + vm.programId + '&datetime=' + vm.date + '&totalMarks=' + vm.totalmarks, {
          candidates: vm.candidates,
          test: vm.test,
        })
          .then(function (res) {
            endReq();
            
            if (!res.data.status) {
              var error = res.data.error;
              for (var i = 0; i < error.length; i++) {
                toastr.error(error[i] + " is required", "Error!");
              }
            }
            else if (res.data.status) {
              toastr.success("Saved successfully", "Done!");
              setTimeout(function () {
                window.location = "/Admission/AllInterviewForm";
              }, 1200);

            }
            else {
              toastr.error("Access Denied", "Error!");
              console.log(res.data);
            }
          })
          .catch(function (res) {
            console.log(res.data);
          });
      },

      semesterChange() {
        this.test.DegreeID = 0;
      },
      Cancel() {
        window.location.href = "../Admission/AllInterviewForm"
      },
      degreeChange() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadProgramDegreeWise?degID=' + vm.test.DegreeID + '&semID=' + vm.test.ActiveSemesterID)
          .then(function (p) {
            vm.programs = p.data.program;
            endReq();
          });
      },
      checkEntryTestUpdate() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const interID = params.get('id');
        const totalMarks = params.get('totalmarks');
        axios.post('/api/AdmissionApi/loadDegrees')
          .then(function (d) {
            vm.degrees = d.data.lst;
            vm.date = d.data.date;
            startReq();
            axios.post('/api/AdmissionApi/loadActiveSemesters')
              .then(function (sem) {
                vm.semesters = sem.data.lst;
                endReq();
                if (totalMarks != null || interID != null) {
                  axios.post('/api/AdmissionApi/checkinterviewupdate?id=' + interID + '&totalmarks=' + totalMarks)
                    .then(function (response) {
                      if (response.data.status) {
                        var d = response.data.test;
                        console.log(d);
                        //$('#date').val(data.date);
                        //$('#time').val(data.time);
                        axios.post('/api/AdmissionApi/loadProgramDegreeWise?degID=' + d.DegreeID + '&semID=' + d.ActiveSemesterID)
                          .then(function (res) {
                            vm.isupdate = true;
                            vm.programs = res.data.program;
                            vm.totalmarks = response.data.totalmarks;
                            vm.test = d;
                            vm.candidates = response.data.candidates;
                            var dd = res.data.program;
                            
                            //CKEDITOR.instances['header'].setData(vm.test.Header);
                            //CKEDITOR.instances['footer'].setData(vm.test.Footer);
                            vm.programId = dd[0].ProgramID;
                            endReq();
                          });
                      }
                      else {
                        endReq();
                      }
                    })
                    .catch(function (res) {
                      console.log(res.data);
                    })
                }
              })
          })
          .catch(function (d) {
            console.log(d);
          });
      },
      loadCandidates() {
        var vm = this;
        startReq();
        //vm.programId = []

        //for (i = 0; i < vm.selectedPrograms.length; i++) {
        //    vm.programId.push(vm.selectedPrograms[i].ProgramID);
        //}


        axios.post('/api/AdmissionApi/loadAllCandidates?pro=' + vm.programId, {
          //halls: vm.halls,
          test: vm.test,
        })
          .then(function (res) {
            endReq();
            vm.candidates = res.data.lst

            if (vm.candidates.length == 0) {
              toastr.info("No candidate found", "Info!");
            }
          })
          .catch(function (res) {
            endReq();

          });
      },
      save(e) {
        e.preventDefault();
        //vm.test.Header = CKEDITOR.instances['header'].getData();
        //vm.test.Footer = CKEDITOR.instances['footer'].getData();
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/saveNewInterview?pro=' + vm.programId + '&datetime=' + vm.date + '&totalMarks=' + vm.totalmarks, {
          test: vm.test,
          candidates: vm.candidates,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              endReq();
              //var result = res.data.error;
              //var rs = JSON.parse(result);
              vm.reset();
              if (!res.data.status) {
                var error = rs.error;
                for (var i = 0; i < error.length; i++) {
                  toastr.error(error[i] + " is required", "Error!");
                }
              }
              else if (res.data.status) {
                toastr.success("Saved successfully", "Done!");
                setTimeout(function () {
                  window.location = "/Admission/AllInterviewForm";
                }, 1200);

              }
              else {
                console.log(res.data.error);
              }
            }
            else
              toastr.error(res.data.error);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },
      reset() {
        this.isupdate = false;
        //this.programs = 0;
        //this.degrees = 0;
        //this.sessions = 0;
        this.selecteddeptid = 0;
        this.halls = '';
        this.test.Name = '';
        this.test.ProgramID = 0;
        this.test.DegreeID = 0;
        this.test.SessionID = 0;
        this.candidates = [];
        $('#date').val();
        $('#time').val();
      }
    }
  });



  // register globally

  //Date picker
  //  $('#date').datepicker({
  //autoclose: true
  //  })

  //  //Timepicker
  //  $('.timepicker').timepicker({
  //showInputs: false
  //  })

  //CKEDITOR.replace('header');
  //CKEDITOR.replace('footer');

      //  function functionx(evt) {
      //      if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57)) {
      //alert("Allow Only Numbers");
      //          return false;
      //      }
      //  };
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/newInterviewForm.vue